<template>
  <div class="login-sms">
    <div class="modal login-sms-modal">
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <div v-show="!smsSent">
            <div class="subtitle is-size-4">
              <p v-if="msg" class="msg subtitle has-text-grey">
                {{ msg }}
              </p>
              <p class="subtitle">
                {{ $t("login.enter-mobile") }}
              </p>
            </div>
            <div class="field has-addons is-fullwidth">
              <p class="control is-large">
                <a
                  class="button is-info is-large is-rounded"
                  style="padding: 0px 12px"
                  @click="openCountryCodeModal"
                  >{{ countryCode }}</a
                >
              </p>
              <div class="control has-icons-right is-expanded">
                <input
                  v-model="phoneNumber"
                  class="input is-large has-text-centered is-rounded"
                  type="number"
                  maxlength="12"
                  placeholder="123456789"
                  v-on:keyup="checkPhoneLength(phoneNumber, 14)"
                />
                <span class="icon is-small is-right">
                  <i class="fas fa-phone"></i>
                </span>
              </div>
            </div>

            <div v-if="isForeignLogin">
              <br />
              <p class="label channel-notice">
                Non-Thai phone numbers will receive login code via
                <i class="fab fa-whatsapp icon"></i>Whatsapp or
                <i class="fab fa-telegram icon"></i>Telegram
              </p>
            </div>

            <br />
            <div v-if="isForeignLogin" class="buttons is-centered">
              <a
                class="button is-medium is-rounded channel-btn whatsapp-btn"
                @click="submitPhoneNumber('whatsapp')"
              >
                <i class="fab fa-whatsapp" />&nbsp;Whatsapp
              </a>
              <a
                class="button is-medium is-rounded channel-btn telegram-btn"
                @click="submitPhoneNumber('telegram')"
              >
                <i class="fab fa-telegram" />&nbsp;Telegram
              </a>
            </div>
            <div v-else>
              <a
                class="button is-success is-medium is-rounded"
                @click="submitPhoneNumber()"
                >{{ $t("confirm") }}</a
              >
            </div>
          </div>

          <div v-show="smsSent">
            <p class="subtitle has-text-grey">
              {{ $t("login.sms-sent-to") }}
              <span class="link" @click="help">{{ fullNumber }}</span>
            </p>
            <p class="subtitle">
              {{ $t("login.please-enter-code") }}
            </p>
            <div class="field has-addons is-fullwidth">
              <div class="control has-icons-left has-icons-right is-expanded">
                <input
                  v-model="inputCode"
                  class="input is-large has-text-centered is-rounded is-fullwidth"
                  type="number"
                  placeholder="4-digit code"
                  v-on:keyup="checkCode(false)"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-key"></i>
                </span>
              </div>
              <div class="control">
                <a
                  class="button is-large is-rounded has-text-info"
                  style="padding: 0px 16px"
                  :disabled="resent"
                  @click="resendSMS"
                >
                  <i class="fa fa-redo-alt" />
                </a>
              </div>
            </div>
            <br />
            <a
              class="button is-success is-medium is-rounded"
              @click="checkCode(true)"
              >{{ $t("submit") }}</a
            >
          </div>
          <div v-if="smsSent" style="margin-top: 20px">
            <p @click="showEmailLogin = !showEmailLogin">
              <i class="link has-text-grey">{{
                $t("login.get-code-via-email")
              }}</i>
            </p>

            <div
              v-if="showEmailLogin"
              class="field has-addons is-fullwidth"
              style="margin-top: 10px; padding-bottom: 10px"
            >
              <div class="control has-icons-left is-expanded">
                <input
                  v-model="email"
                  class="input is-fullwidth is-rounded is-medium"
                  :placeholder="$t('login.enter-email-address')"
                />
                <span class="icon is-small is-left">
                  <i class="far fa-envelope"></i>
                </span>
              </div>
              <div class="control">
                <a
                  class="button has-text-info is-rounded is-medium"
                  :disabled="!validEmail"
                  @click="sendEmailCode"
                >
                  <i class="fa fa-paper-plane" />
                </a>
              </div>
            </div>
          </div>
          <div v-if="error" style="margin-top: 10px">
            <p class="has-text-danger">{{ error }}</p>
          </div>
        </section>
      </div>
    </div>
    <CountryCodeModal @countryCode="onCountryCode" />
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import CountryCodeModal from "@/components/CountryCodeModal.vue";

export default {
  name: "LoginSMSModal",
  components: {
    CountryCodeModal,
  },
  props: {
    verify: Boolean,
  },
  data() {
    return {
      error: null,
      msg: null,
      isValidNumber: false,
      smsSent: false,
      phoneNumber: "",
      inputCode: "",
      // maxTime: 300,
      // timer: 0,
      countryCode: "+66", // change later based on selectedBusiness
      resent: false, // true after user has tried to resend once
      callback: null,
      showEmailLogin: false,
      email: null,
    };
  },
  computed: {
    isForeignLogin() {
      // if (!this.countryCode) return false;
      return this.countryCode != "+66";
    },
    fullNumber() {
      return this.parsePhoneNumber();
    },
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    validEmail() {
      if (!this.email) return false;
      return this.email.includes("@");
    },
    // loginAge() {
    //   var previous = this.$store.state.magicLogin;
    //   if (!previous) return 0;
    //   var age = (new Date() - new Date(previous.created_at)) / 1000;
    //   return age;
    // }
  },
  mounted() {
    this.checkAge();
    EventBus.$on("OPEN_LOGIN_SMS_MODAL", (payload) => {
      console.log("open login sms", payload);
      if (payload) {
        this.msg = payload.msg;
        this.callback = payload.callback;
      } else {
        this.msg = null;
        this.callback = null;
      }
      this.setDefaultCountryCode();
      this.checkAge();
    });
  },
  methods: {
    closeModal() {
      this.phoneNumber = "";
      this.smsSent = false;
      this.inputCode = "";
      this.error = null;
      this.isValidNumber = false;
      this.resent = false;
      this.msg = null;
      // this.callback = null;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    openWhatsApp() {
      const tukWhatsappNumber = "66909588716";
      const message = `Hello! I would like to login to TUK App using my Whatsapp number ${this.parsePhoneNumber()}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/${tukWhatsappNumber}?text=${encodedMessage}`;
      window.open(whatsappUrl, "_blank"); // Opens in a new tab/window
    },
    openTelegram() {
      // t.me links need a username (a phone number is not a valid handle)
      const tukTelegramUsername = "tukappth";
      const message = `Hello! I would like to login to TUK App using my Telegram number ${this.parsePhoneNumber()}`;
      const encodedMessage = encodeURIComponent(message);
      const telegramUrl = `https://t.me/${tukTelegramUsername}?text=${encodedMessage}`;
      window.open(telegramUrl, "_blank"); // Opens in a new tab/window
    },
    setDefaultCountryCode() {
      if (!this.$store.state.selectedBusiness) return;
      var country = this.$store.state.selectedBusiness.country;
      switch (country) {
        case "th":
          this.countryCode = "+66";
          break;
        case "jp":
          this.countryCode = "+81";
          break;
        case "pt":
          this.countryCode = "+351";
          break;
        case "sg":
          this.countryCode = "+65";
          break;
      }
    },
    checkAge() {
      var previous = this.$store.state.magicLogin;
      if (!previous) return;
      var age = (new Date() - new Date(previous.created_at)) / 1000;
      // console.log("checkAge", age);
      if (age < 90) {
        this.smsSent = true;
        this.phoneNumber = previous.source_user_id;
      }
    },
    sendEmailCode() {
      if (!this.validEmail) {
        return (this.error = "Enter a valid email address");
      }
      this.log("sms_login_send_email_code", this.email);
      this.error = null;
      var loader = this.loadingDots();
      this.$store
        .dispatch("sendLoginEmail", {
          mobile: this.parsePhoneNumber(),
          email: this.email,
          uuid: this.$store.getters.getUUID,
          magic_login_id: this.$store.state.magicLogin.id,
        })
        .then((res) => {
          this.console(res);
          var msg = "Please check your e-mail<br>(and spam folder)";
          this.infoToast(msg, "top");
        })
        .catch((err) => console.error(err))
        .finally(() => {
          loader.hide();
          this.showEmailLogin = false;
        });
    },
    openCountryCodeModal() {
      this.displayModal(".country-code-modal");
    },
    onCountryCode(val) {
      this.console("countryCode value", val);
      this.countryCode = val;
    },
    help() {
      this.log("sms_login_help", this.fullNumber);
      this.sendSuperuserNotification(
        `SMS login help ${this.fullNumber}, code:`
      );
      var blue = this.bulmaColor("info");
      this.$swal({
        // type: "info",
        title: `<i class='fa fa-sms fa-2x'></i>`,
        html: `<div style='text-align:left'>
        SMS was sent to <strong>${this.fullNumber}</strong>
        <br><br>
        If you don't receive an SMS within 90 seconds
        <a href="https://m.me/tukapp" target="_blank" style='text-decoration: underline'>
        click here for login support.</a>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "Oops, Wrong Number",
        cancelButtonColor: "orange",
        confirmButtonColor: blue,
      }).then((val) => {
        if (val.dismiss === "cancel") {
          this.$store.commit("clearMagicLogin", "wrong number");
          this.smsSent = false;
        }
      });
    },
    // Indo phone numbers can have up to 14 digits, SG 8, TH 9, US 10 etc
    checkPhoneLength(val, length) {
      if (val.length > length) {
        this.phoneNumber = val.substring(0, length);
        this.error = `Phone number is too long`;
        return;
      }
      this.error = null;
    },
    parsePhoneNumber() {
      var cleanNumber = this.phoneNumber;
      if (this.phoneNumber.length < 7) return "";
      if (this.phoneNumber[0] === "0") {
        cleanNumber = this.phoneNumber.substring(1, this.phoneNumber.length);
      }
      this.console("cleanNumber", cleanNumber); // skip initial 0 for Thai numbers
      if (this.phoneNumber[0] === "+") return this.phoneNumber;
      return this.countryCode + cleanNumber;
    },
    checkCode(showError) {
      if (this.inputCode.length > 4) {
        this.inputCode = this.inputCode.substring(0, 4);
        return;
      }
      // this.console(`checkCode: ${this.verificationCode} vs ${this.inputCode}`);
      if (this.inputCode.length < 4) {
        if (showError) {
          this.error = this.$t("login.please-enter-code");
          return;
        }
        this.error = null;
        return;
      }
      if (isNaN(this.inputCode)) {
        this.error = "Code should be a number";
        return;
      }
      this.error = null;
      // otherwise length is 4 so check code
      if (this.isAppleTester()) return this.loginAppleTester();
      var loader = this.loadingDots();
      this.$store
        .dispatch("fourDigitLoginVerify", this.inputCode)
        .then(() => {
          this.log("sms_login_success");
          this.updateRoles(false); // needed to get workflows
          document.activeElement.blur(); // ios safari hack to close keyboard
          this.closeModal();
          // should emit callback here if there is one...
          // if (this.callback) return EventBus.$emit(this.callback);
          // otherwise normal end flow
          if (!this.$store.getters.realName) this.setName(this.callback);
          else if (this.callback) EventBus.$emit(this.callback);
          else this.loginSuccessAlert();
        })
        .catch((err) => {
          if (err.response) this.error = err.response.data;
          else this.apiError(err);
        })
        .finally(() => loader.hide());
    },
    isAppleTester() {
      if (this.phoneNumber === "5533771" && this.inputCode === "5371")
        return true;
    },
    loginAppleTester() {
      var id = "d152f924-3aa1-11ea-b6db-6a5cbd7fc2c9"; // prod
      // var id = "abd48ee6-33a4-11ea-b10a-be99a1d4b9c1"; // staging
      this.$router
        .push(`/profile?apple_user=${id}`) // a user_id
        .catch((err) => this.apiError(err))
        .finally(() => location.reload()); // reload to login the user
    },
    random4digits() {
      var seq = (Math.floor(Math.random() * 10000) + 10000)
        .toString()
        .substring(1);
      return seq;
    },
    resendSMS() {
      if (this.resent) return this.help(); // don't resend if already resent once
      this.infoToast("Re-sent SMS", "top");
      this.resent = true;
      if (this.$store.state.notificationToken === "") return; // can't send if no notification
      var loader = this.loadingDots();
      this.$store
        .dispatch("fourDigitLoginResend")
        .then(() => (this.smsSent = true))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    // channel: "whatsapp" | "telegram" for non-Thai numbers (CS sends the code
    // manually), undefined for Thai numbers (code is sent by SMS)
    submitPhoneNumber(channel) {
      if (typeof channel !== "string") channel = undefined; // @click passes the event
      this.requestPersistedStoragePermission();
      this.log("sms_login_submit_mobile", this.parsePhoneNumber());
      if (this.countryCode === "+66") {
        var removeZero = this.phoneNumber.replace(/^0+/, "");
        if (removeZero.length !== 9) {
          return (this.error = "Thai mobile numbers have 9 digits");
        }
      }
      if (this.phoneNumber.length < 7) {
        return (this.error = "Please enter a valid phone number");
      }
      if (isNaN(this.phoneNumber)) {
        return (this.error = "Phone number should be a number");
      }
      if (!this.verify && this.loggedIn) {
        return this.savePhoneNumber();
      }
      this.error = null; // clear any previous errs
      this.sendSuperuserNotification(
        `SMS login triggered: ${this.parsePhoneNumber()}`
      );
      var loader = this.loadingDots();
      // source says how the code reaches the user: "sms" (Thai numbers) or
      // "whatsapp" / "telegram" (non-Thai, CS sends the code by hand)
      const payload = {
        source: this.isForeignLogin && channel ? channel : "sms",
        source_user_id: this.parsePhoneNumber(),
      };
      this.$store
        .dispatch("loginStart", payload)
        .then(() => {
          this.smsSent = true;
          if (this.isForeignLogin && channel === "telegram") this.openTelegram();
          else if (this.isForeignLogin) this.openWhatsApp();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    savePhoneNumber() {
      if (!this.loggedIn) return alert("user not logged in"); // shouldn't hit this
      // if not verifying then just save to user, i.e. new FB/Line user
      var loader = this.loadingDots();
      this.$store
        .dispatch("setPhoneNumber", this.parsePhoneNumber())
        .then((res) => this.console("updated phone number", res))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.closeModal();
        });
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  width: 95vw;
  max-width: 500px;
  margin: 0 auto;
  padding: 16px 12px;
  border-radius: 25px;
}

.field {
  margin-bottom: 0 !important;
}

.subtitle {
  font-weight: 600;
  margin-bottom: 16px !important;
}

.msg {
  margin-bottom: 10px !important;
  font-weight: 500;
}

.link {
  border-bottom: 1px #ccc dotted;
}
.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 10px;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.5);
  }
}

/* ---- non-Thai login: WhatsApp / Telegram (soft card + equal pill buttons) ---- */
.channel-notice {
  margin: 0;
  padding: 12px 14px;
  border-radius: 18px;
  border: 1px solid rgba(135, 206, 235, 0.65);
  background-color: rgba(135, 206, 235, 0.12);
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.6;
}

.channel-btn {
  min-width: 9.5em;
  height: 3em;
  padding: 0 18px;
  border: 0;
  color: #fff;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(31, 27, 36, 0.14);
}

.whatsapp-btn {
  background: linear-gradient(180deg, #3ee07a 0%, #25d366 100%);
}

.telegram-btn {
  background: linear-gradient(180deg, #3fb4e8 0%, #229ed9 100%);
}

.channel-btn:active {
  transform: scale(0.97);
}

/* ---- dark theme (generated) ---- */
/* light-only colours above, re-mapped to the theme variables in dark mode */
html[data-theme="dark"] .link {
  border-bottom-color: var(--line);
}
</style>
